import { debtStatusEnumLabels } from '~/shared/config/constants'
import { DebtStatusesEnum } from '~/shared/config/enums'
import { TMS_DOMAIN } from '~/shared/config/env'
import {
  AsyncGridColumns,
  ColumnDate,
  ColumnLink,
  ColumnValue,
} from '~/shared/ui/AsyncGrid'
import { ChipStatus } from '~/shared/ui/Chips'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.date and time',
    field: 'startAt',
    minWidth: 190,
    renderCell: ({ row, value }) => (
      <ColumnLink to={row.id}>
        <ColumnDate type='dateTime' value={value} />
      </ColumnLink>
    ),
  },
  {
    headerName: 'column.status',
    field: 'status',
    minWidth: 192,
    renderCell: ({ row }) => {
      const variant =
        row.status === DebtStatusesEnum.SUSPENDED
          ? 'gray'
          : row.status === DebtStatusesEnum.PAID
          ? 'green'
          : row.status === DebtStatusesEnum.PROCESSING
          ? 'yellow'
          : null

      if (!variant) return null

      return (
        <ChipStatus
          labelI18n={debtStatusEnumLabels[row.status]}
          variant={variant}
        />
      )
    },
  },
  {
    headerName: 'column.type',
    field: 'sourceType',
    minWidth: 192,
    renderCell: ({ row }) => <ColumnValue>{row.sourceType}</ColumnValue>,
  },
  {
    headerName: 'column.total',
    field: 'total',
    minWidth: 180,
    renderCell: ({ value }) => (
      <ColumnValue>{value.toLocaleString()}</ColumnValue>
    ),
  },
  {
    headerName: 'column.payment cost',
    field: 'paymentCost',
    minWidth: 180,
    renderCell: ({ value }) => (
      <ColumnValue>{value.toLocaleString()}</ColumnValue>
    ),
  },
  {
    headerName: 'column.paid',
    field: 'paid',
    minWidth: 180,
    renderCell: ({ value }) => (
      <ColumnValue>{value.toLocaleString()}</ColumnValue>
    ),
  },
  {
    headerName: 'column.balance',
    field: 'balance',
    minWidth: 180,
    renderCell: ({ value }) => (
      <ColumnValue>{value.toLocaleString()}</ColumnValue>
    ),
  },
  {
    headerName: 'column.source',
    field: 'source',
    minWidth: 192,
    sortable: false,
    renderCell: ({ value }) => {
      return value.url ? (
        <ColumnLink href={value.url} target='_blank'>
          {value.title}
        </ColumnLink>
      ) : (
        <ColumnValue>{value.title}</ColumnValue>
      )
    },
  },
  {
    headerName: 'column.driver',
    field: 'driver',
    minWidth: 350,
    sortable: false,
    renderCell: ({ row, value }) =>
      value && (
        <ColumnLink
          href={`${TMS_DOMAIN}drivers/${row.driverExtId}`}
          target='_blank'
        >
          {value}
        </ColumnLink>
      ),
  },
  {
    headerName: 'column.car',
    field: 'car',
    minWidth: 189,
    sortable: false,
    renderCell: ({ row, value }) =>
      value && (
        <ColumnLink href={`${TMS_DOMAIN}cars/${row.carExtId}`} target='_blank'>
          {value}
        </ColumnLink>
      ),
  },
  {
    headerName: 'column.is erroneous',
    field: 'isErroneous',
    minWidth: 200,
    sortable: false,
    renderCell: ({ value }) => {
      return (
        <ChipStatus
          labelI18n={value ? 'column.yes' : 'column.no'}
          variant={value ? 'green' : 'gray'}
        />
      )
    },
  },
]
